import React, { useEffect, useState } from 'react'
import ModalEnabled from '../../../components/modalComponents/ModalEnabled';
import PageHeader from '../../../components/pageHeader/PageHeader';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import PageButtons from '../../../components/pageComponents/PageButtons';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import { getCampanasIndexAPI } from '../../../consumers/backendApisUrls';
import styled from "styled-components";
import TableCampanha from './TableCampanha';
import PageWrapper from '../../../components/pageComponents/PageWrapper';
import CrearCampanha from './modales/CrearCampanha';

const AdminGestionDeCampanhas = () => {
  const INIT_KEYS = { idsParents: "IdsParents", idsTypes: "IdsTypes" };
  const [formValues, setFormValues] = useState({
    Items: [],
    ExtraData: {},
    filters: [],
    selectedFilters: {},
  });

  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [isLoading, setIsLoading] = useState(true);

  const [modalEnabled, setModalEnabled] = useState({
    isEnable: false,
    component: React.Fragment,
  });

  const [executeManagePost] = useManagePostRequest();

  const init = async () => {
    setIsLoading(true);
    try {
      await manageSearch();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const manageSearch = async () => {
    setIsLoading(true);
    const api = getCampanasIndexAPI();
    const payload = getPayload();
    try {
      await executeManagePost(api, payload, successManageSearchCallback);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCleanSearch = () => {
    setFormValues({ ...formValues, selectedFilters: null });
  };

  const getPayload = () => {
    return {
      Criteria: searchCriteria,
      Page: paginator.CurrentPage,
      ...formValues.selectedFilters,
    };
  };

  const successManageSearchCallback = ({ data }) => {
    const {
      Items,
      ExtraData,
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
    } = data;
    const updatedItems = Items.map((o) => {
      const { IdPlantillaCuponTiempoLibre, ImagenCuponTiempoLibreURL } = o;
      return {
        ...o,
        Id: IdPlantillaCuponTiempoLibre,
        ImagenUrl: ImagenCuponTiempoLibreURL,
      };
    });
    setFormValues((lastData) => ({
      ...lastData,
      Items: updatedItems,
      ExtraData,
    }));
    setPaginator({
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
    });
  };
    
  useEffect(() => {
    init();
  }, [])

  return (
    <>
      <PageWrapper isLoading={isLoading}>
        <ModalEnabled
          modalEnabled={modalEnabled}
          setModalEnabled={setModalEnabled}
          refreshPage={manageSearch}
        />
        <PageHeader title="Gestión de campañas" />
        <SearchContainer
          searchCriteria={searchCriteria}
          setSearchCriteria={setSearchCriteria}
          setPaginator={setPaginator}
          manageSearch={manageSearch}
          addCleanSearch={handleCleanSearch}>
          <PageButtons
            hasBackButton
            hasCreateButton
            handleCreateButton={() =>
              setModalEnabled({ isEnable: true, component: CrearCampanha })
            }
          />
        </SearchContainer>
        <TableCampanha
          formValues={formValues}
          setFormValues={setFormValues}
          setModalEnabled={setModalEnabled}
          paginator={paginator}
          setPaginator={setPaginator}
          keys={INIT_KEYS}
        />
      </PageWrapper>
    </>
  );
};

export default AdminGestionDeCampanhas;

const ButtonsWrapper = styled.div`
  display: block;
  @media (max-width: 796px){
    display: none;
  }
`;